/** The SelectListEvent represents a item selection change, caused by the user or replacing the data source. */
export default class SelectListEvent<Item> extends Event {
	/**
	 * The static SELECTION_CHANGED property is used by the listeners, so we dont't get typo bugs.
	 *
	 * Example: addEventListener(SelectListEvent.SELECTION_CHANGED, (event: SelectListEvent<string>) => {});
	 */
	public static SELECTION_CHANGED = 'SelectListEvent.selectionChanged';
	/**
	 * The selectedItem property is the Item value in the data property at the selectedIndex position.
	 *
	 * Or in other words, the item property value of the ItemRenderer that's currently selected.
	 */
	public selectedItem: Item | null;

	/** The selectedItems is an Array that contains the currently selected ItemRenderers.data Items. */
	public selectedItems: Item[];

	public constructor(selectedItem: Item | null = null, selectedItems: Item[] = []) {
		super(SelectListEvent.SELECTION_CHANGED, { bubbles: true });
		this.selectedItem = selectedItem;
		this.selectedItems = selectedItems;
	}
}
